import type { Tendon } from "../types/scene";

type TendonVisualizationUpdater = (tendons: Tendon[]) => void;

let updater: TendonVisualizationUpdater | null = null;

export function setTendonVisualizationUpdater(next: TendonVisualizationUpdater | null) {
  updater = typeof next === "function" ? next : null;
}

export function hasTendonVisualizationUpdater(): boolean {
  return typeof updater === "function";
}

export function updateTendonVisualization(tendons: Tendon[]) {
  if (!updater) return;
  updater(Array.isArray(tendons) ? tendons : []);
}
